




// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
//按需加载
import '@/element-ui'
//主题加载
import '@/theme/0261E4/index.css'
//挂载公共方法
import comm from '@/utils/common'
//挂载配置
import website from '@/utils/website'
//bus
import bus from '@/utils/bus'
//挂载rem
import '@/plugs/lib-flexible'
// rem适配
// import '../static/config/rem'
import lang from '@/config/i18n/zh-cn'
// css样式
import '../static/css/base.css'
import '../static/font/font.css'
import '../static/css/common.css'
import '../static/font/nanwang/iconfont.css'
import '../static/font/nanwang/iconfont.js';
//权限验证
import '@/utils/permission'
//基本样式
import '@/theme/base.css'
//导入
import axios from 'axios'
//导入(this)Vue.axios.get
import VueAxios from 'vue-axios'
//导入svg
import Icon from '@/components/Icon'
//导入自定义图标
import './assets/icon/iconfont.css'
import './assets/icon/custom/iconfont.css'
import './assets/icon/design/iconfont.css'
//引入这个懒加载插件
import VueLazyload from 'vue-lazyload'
//播放器
import VueVideoPlayer from 'vue-video-player'
// 引入video.js
import Videojs from 'video.js'
//video样式
import 'video.js/dist/video-js.css'
//播放器样式
import 'vue-video-player/src/custom-theme.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(VueVideoPlayer);
// 或者添加VueLazyload 选项
Vue.use(VueLazyload, {
    preLoad: 1.3,
    // error: 'dist/error.png',
    // loading: 'dist/loading.gif',
    attempt: 3
})
Vue.prototype.$video = Videojs
Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.component('Icon',Icon);
Vue.prototype.COMM = comm;
Vue.prototype.Bus = bus;
Vue.prototype.lang = lang;
Vue.use(Viewer)
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function () {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})

Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
window.Bus = bus;
window.COMM = comm;
window.$SITE = website;

/* eslint-disable no-new */
/* eslint-disable */

// 全局过滤器
Vue.prototype.filterJsonStrParse =  function (val, key) { 
  let res = ''
  if(val==='-')return  val
  try {
    res = JSON.parse(val)[key]
  } catch (error) { }
  return res;
}
Vue.filter("jsonStrParse",Vue.prototype.filterJsonStrParse)


Vue.prototype.filterGetStatusByValue =  function (val, statusmap) { 
  if(!statusmap)return  val;
  if(val==='-')return  val
  val = parseInt(val)
  if(!statusmap[val])return  '-';
  return statusmap[val].name;
}
Vue.filter("getStatusByValue",Vue.prototype.filterGetStatusByValue)

Vue.prototype.jsonparse =  function (val) { 
  //只是用来调试数据
  console.log(val);
    return 1|| JSON.parse(val);
}
Vue.filter("jsonparse",Vue.prototype.jsonparse)

window.$vm = new Vue({
  el: '#app',
  router,
  store,

  data(){
    return {
      rem
    }
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js